import * as React from "react";
import PageHeader from '../../common/pageheader/PageHeader';
import {
    MessageBar,
    MessageBarType,
    Link
} from '@fluentui/react';

export const GoLocalsReport: React.FC = (props) => {
    return (
        <div>
            <PageHeader
                title="Go Locals Report"
                description="The report contains information about launched go locals and incoming go locals."
            />
            <MessageBar>
                Please go to
                <Link href="https://aka.ms/tesseract/m2cp/golocals" inline>
                    aka.ms/tesseract/m2cp/golocals
                </Link>{' '}
                to check original report
            </MessageBar>
            <iframe title="M2CP"
                style={{ width: '100%', height: '850px', marginTop: '20px' }}
                src="https://msit.powerbi.com/reportEmbed?reportId=5446c161-2a94-4759-8a06-0a0a1bb84f79&autoAuth=true&ctid=72f988bf-86f1-41af-91ab-2d7cd011db47"
                frameBorder={0}
                allowFullScreen={true}></iframe>
        </div>

    )
}